import "./CustomSearchbar.scss";

import React, { memo } from "react";

import PropTypes from "prop-types";
import { DebounceInput } from "react-debounce-input";
import { IoClose, IoSearch } from "react-icons/io5";

const CustomSearchbar = ({
  searchQuery,
  setSearchQuery,
  onSearch,
  onClear,
  placeholder,
  style = {},
  ...props
}) => {
  const handleSearch = (e) => {
    if (e) {
      if (onSearch) {
        onSearch(e.target.value);
        return;
      }
      setSearchQuery(e.target.value);
    }
  };

  const handleClear = () => {
    if (onClear) {
      onClear();
      return;
    }
    setSearchQuery("");
  };

  return (
    <div className="customSearchBarWrapper" style={{ ...style }}>
      <IoSearch size={20} className="search-icon" />

      <DebounceInput
        className="customSearchBar"
        value={searchQuery}
        debounceTimeout={1000}
        onChange={handleSearch}
        placeholder={placeholder || "Search by name, phone or email"}
        {...props}
      />

      {searchQuery && searchQuery !== "" && (
        <IoClose
          onClick={handleClear}
          className="search-clear-icon"
          size={20}
        />
      )}
    </div>
  );
};
CustomSearchbar.propTypes = {
  searchQuery: PropTypes.string.isRequired,
  setSearchQuery: PropTypes.func.isRequired,
  onSearch: PropTypes.func,
  onClear: PropTypes.func,
  placeholder: PropTypes.string,
  style: PropTypes.shape(),
  [PropTypes.string]: PropTypes.shape(),
};

export default memo(CustomSearchbar);
